import JobPublicLinkStatus from '../types/job-public-link-status.type';

export const JOB_PUBLIC_LINK_STATUS: Record<JobPublicLinkStatus, JobPublicLinkStatus> = {
  'active': 'active',
  'accepted': 'accepted',
}